import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/** TVG-342: an extra email address held on a contact, beside their main one. */
export interface ContactEmailAddress {
  id: number;
  email: string;
  created_at: string | null;
}

export interface AddContactEmailAddressResponse {
  /** Null when the contact already held the address and adding it only filed what was waiting from it. */
  data: ContactEmailAddress | null;
  /** How many Not filed emails from the address have just moved onto the contact. */
  filed: number;
}

/**
 * TVG-342: HTTP wrapper for a contact's extra email addresses. Adding one is
 * how staff file a reply that arrived from an address no contact held.
 */
@Injectable({
  providedIn: 'root',
})
export class ContactEmailAddressService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  list(contactId: number): Observable<{ data: ContactEmailAddress[] }> {
    return this.http.get<{ data: ContactEmailAddress[] }>(`${this.apiUrl}/api/contacts/${contactId}/email-addresses`);
  }

  add(contactId: number, email: string): Observable<AddContactEmailAddressResponse> {
    return this.http.post<AddContactEmailAddressResponse>(`${this.apiUrl}/api/contacts/${contactId}/email-addresses`, {
      email,
    });
  }

  remove(contactId: number, addressId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/api/contacts/${contactId}/email-addresses/${addressId}`);
  }
}
